import axios from "axios";
import router from "@/router";
import { Message } from 'element-ui';
import store from "@/store";
import { ensureVisitor } from "@/utils/uuid_token";
const openApiHttp = (config, flag) => {
    const instance = axios.create({
        baseURL: process.env.VUE_APP_API,
        headers: { 'content-type': 'application/x-www-form-urlencoded' }

    });

    // 添加请求拦截器  
    instance.interceptors.request.use(
        config => {
            // 在发送请求之前做些什么  
            const token = localStorage.getItem("token");
            if (config.method === 'get') {
                config.headers['Cache-Control'] = 'max-age=100'
            }
            if (token) {
                config.headers["Authorization"] = token; // 假设你的后端期望这样的格式  
            } else {
                config.headers["Authorization"] = localStorage.getItem("uuidtoken")

            }
            return config;
        },
        error => {
            // 对请求错误做些什么  
            return Promise.reject(error);
        }
    );

    // 添加响应拦截器  
    instance.interceptors.response.use(
        response => {
            // 对响应数据做点什么
            // 例如，你可以在这里处理全局的错误码 
            // console.log(response.status);
            if (response.status === 200) {
                if (response.data.code == 1001) {
                    if (localStorage.getItem("token")) {
                        // 真实用户：登录过期/失效 → 清 token、提示并去登录
                        localStorage.removeItem("token");
                        store.dispatch('login')
                        Message({
                            message: 'The login expired or invalid',
                            type: 'error',
                            duration: 2000,
                            onClose: () => {
                                //此处写提示关闭后需要执行的函数
                                router.replace('/login')
                            }
                        })
                    } else {
                        // 游客：访客会话失效 → 静默重建，不打断、不跳登录
                        localStorage.removeItem("uuidtoken");
                        ensureVisitor().then(() => store.dispatch('login'))
                    }
                }
                // 无论是否 1001 都返回信封，避免 1001 时返回 undefined 喂进 .then 崩溃
                return response.data;
            }
            return response;
        },
        error => {
            if ([401, 403].includes(error.status)) {
                // 无访问权限，可能情况有
                // 401:没传token或者使用伪造的token
                // 403:访客越权访问用户服务
                router.replace('/login')
            }
            // 超出 2xx 范围的状态码都会触发该函数。  
            // 对响应错误做点什么  
            // 例如，你可以在这里统一处理网络错误或服务器错误  
            return Promise.reject(error);
        }
    );
    if (flag) {
        // flag=true 表示该接口必须「真实登录」才能用（充值/评论/点赞/反馈/改资料等）。
        // 游客（仅有访客会话）触发时，提示去登录而非报“登录过期”。
        if (localStorage.getItem("token")) {
        } else {
            setTimeout(() => {
                Message({
                    message: 'Please sign in to continue',
                    type: 'warning',
                    duration: 2000,
                    onClose: () => {
                        //此处写提示关闭后需要执行的函数
                        router.replace({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath }
                        })
                    }
                })
            }, 50);
        }
    }
    return instance.request(config);
};

export default openApiHttp;